import {
    contextService,
    SYSTEM,
} from '../../base/contextService';

export const getCdn = () => {
    let cdn = '';
    switch (contextService.system) {
        case SYSTEM.CN:
            cdn = 'https://statics-cdn-cn.umucdn.cn';
            break;
        case SYSTEM.EN:
        case SYSTEM.EM:
        case SYSTEM.JP:
        case SYSTEM.TW:
            cdn = 'https://cdn.umustatic.com';
        case SYSTEM.ATES:
            cdn = 'https://atescdn.umustatic.com';
            break;
        default:
            break;
    }
    return cdn;
}

export const getStatic = () => {
    let domain = '';
    switch (contextService.system) {
        case SYSTEM.CN:
            domain = 'https://statics-umu-cn.umucdn.cn';
            break;
        case SYSTEM.EN:
            domain = 'https://statics00.umustatic.com';
            break;
        case SYSTEM.EM:
            domain = 'https://dmks9efzatfsk.cloudfront.net';
            break;
        case SYSTEM.JP:
            domain = 'https://statics22.umustatic.com';
            break;
        case SYSTEM.TW:
            domain = 'https://statics11.umustatic.com';
            break;
        case SYSTEM.ATES:
            domain = 'https://atescdn.umustatic.com';
            break;

        default:
            break;
    }
    return domain;
}
